import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, BadgeCheck, CalendarDays, Coins, FileText, Layers, Link2, MapPin, Shield, TrendingUp } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Separator } from "@/components/ui/separator";
import { offerings } from "@/mocks/residual";
import { daysUntil, formatDate, formatNumber, formatPct, formatUsd } from "@/lib/format";
const STRATEGY_LABEL = {
  "refund-all": "Refund if not fully funded",
  "partial-ok": "Proceeds even if partially funded",
  extend: "Deadline can be extended by partner"
};
export function OfferingDetailPage(t0) {
  const $ = _c(81);
  const {
    offeringId,
    onBack,
    onBuy
  } = t0;
  let T0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== offeringId || $[1] !== onBack || $[2] !== onBuy) {
    t14 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t15;
      if ($[18] !== offeringId) {
        t15 = x => x.id === offeringId;
        $[18] = offeringId;
        $[19] = t15;
      } else {
        t15 = $[19];
      }
      const o = offerings.find(t15);
      if (!o) {
        let t16;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
          t16 = <ArrowLeft className="size-4" />;
          $[20] = t16;
        } else {
          t16 = $[20];
        }
        let t17;
        if ($[21] !== onBack) {
          t17 = <Button variant="ghost" size="sm" onClick={onBack}>{t16} Back</Button>;
          $[21] = onBack;
          $[22] = t17;
        } else {
          t17 = $[22];
        }
        let t18;
        if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
          t18 = <p className="text-sm text-muted-foreground">Offering not found.</p>;
          $[23] = t18;
        } else {
          t18 = $[23];
        }
        let t19;
        if ($[24] !== t17) {
          t19 = <div className="space-y-4">{t17}{t18}</div>;
          $[24] = t17;
          $[25] = t19;
        } else {
          t19 = $[25];
        }
        t14 = t19;
        break bb0;
      }
      const fundedPct = o.soldTokens / o.tokenSupply * 100;
      const fundedUsd = o.soldTokens * o.tokenPrice;
      const targetUsd = o.tokenSupply * o.tokenPrice;
      const days = daysUntil(o.deadlineAt);
      const sellable = o.status === "sale" || o.status === "tokenized";
      t7 = "space-y-5";
      let t16;
      if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = <ArrowLeft className="size-4" />;
        $[26] = t16;
      } else {
        t16 = $[26];
      }
      if ($[27] !== onBack) {
        t8 = <Button variant="ghost" size="sm" onClick={onBack} className="-ml-2">{t16} Back</Button>;
        $[27] = onBack;
        $[28] = t8;
      } else {
        t8 = $[28];
      }
      const t17 = `url(${o.heroUrl})`;
      if ($[29] !== t17) {
        t9 = <div className="aspect-[16/10] w-full rounded-2xl bg-muted bg-cover bg-center" style={{
          backgroundImage: t17
        }} />;
        $[29] = t17;
        $[30] = t9;
      } else {
        t9 = $[30];
      }
      const t18 = o.kind === "asset" ? "Asset ownership" : "Revenue share";
      let t19;
      if ($[31] !== t18) {
        t19 = <Badge variant="secondary" className="rounded-full font-normal">{t18}</Badge>;
        $[31] = t18;
        $[32] = t19;
      } else {
        t19 = $[32];
      }
      t10 = <div className="space-y-2"><div className="flex flex-wrap gap-1.5">{t19}{o.tags.map(_temp)}{o.requiresAccredited && <Badge variant="outline" className="gap-1 rounded-full font-normal text-amber-700 dark:text-amber-400"><Shield className="size-3" /> Accredited only</Badge>}</div><h1 className="text-2xl font-semibold leading-tight">{o.title}</h1><p className="text-sm text-muted-foreground">{o.subtitle}</p>{o.location && <div className="flex items-center gap-1.5 text-xs text-muted-foreground"><MapPin className="size-3.5" /> {o.location}</div>}</div>;
      let t20;
      if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = <Separator />;
        $[33] = t20;
      } else {
        t20 = $[33];
      }
      let t21;
      if ($[34] !== fundedUsd) {
        t21 = formatUsd(fundedUsd);
        $[34] = fundedUsd;
        $[35] = t21;
      } else {
        t21 = $[35];
      }
      let t22;
      if ($[36] !== t21) {
        t22 = <span className="font-medium">{t21} raised</span>;
        $[36] = t21;
        $[37] = t22;
      } else {
        t22 = $[37];
      }
      let t23;
      if ($[38] !== targetUsd) {
        t23 = formatUsd(targetUsd);
        $[38] = targetUsd;
        $[39] = t23;
      } else {
        t23 = $[39];
      }
      let t24;
      if ($[40] !== t23) {
        t24 = <span className="text-muted-foreground">of {t23}</span>;
        $[40] = t23;
        $[41] = t24;
      } else {
        t24 = $[41];
      }
      let t25;
      if ($[42] !== t22 || $[43] !== t24) {
        t25 = <div className="flex items-baseline justify-between text-sm">{t22}{t24}</div>;
        $[42] = t22;
        $[43] = t24;
        $[44] = t25;
      } else {
        t25 = $[44];
      }
      let t26;
      if ($[45] !== fundedPct) {
        t26 = <Progress value={fundedPct} className="h-2" />;
        $[45] = fundedPct;
        $[46] = t26;
      } else {
        t26 = $[46];
      }
      const t27 = o.status === "sale" ? `${days} day${days === 1 ? "" : "s"} left` : o.status === "active" ? "Generating income" : "Sale closed";
      let t28;
      if ($[47] !== t27) {
        t28 = <span>{t27}</span>;
        $[47] = t27;
        $[48] = t28;
      } else {
        t28 = $[48];
      }
      const t29 = <div className="flex items-center justify-between text-xs text-muted-foreground"><span>{formatNumber(o.soldTokens)} tokens sold</span>{t28}</div>;
      let t30;
      if ($[49] !== t25 || $[50] !== t26 || $[51] !== t29) {
        t30 = <div className="space-y-2">{t25}{t26}{t29}</div>;
        $[49] = t25;
        $[50] = t26;
        $[51] = t29;
        $[52] = t30;
      } else {
        t30 = $[52];
      }
      const t31 = <CardContent className="space-y-4 pt-6"><div className="grid grid-cols-2 gap-4"><Stat label="Token price" value={formatUsd(o.tokenPrice)} hint={`per ${o.tokenSymbol}`} /><Stat label="Total supply" value={formatNumber(o.tokenSupply)} hint={o.tokenSymbol} />{o.projectedYearlyYieldPct !== undefined && <Stat icon={<TrendingUp className="size-3.5" />} label="Target yield" value={formatPct(o.projectedYearlyYieldPct)} hint="annualized" />}{o.revenueShare && <Stat icon={<Coins className="size-3.5" />} label="Revenue share" value={formatPct(o.revenueShare.percent)} hint={`${o.revenueShare.windowMonths} mo • ${o.revenueShare.payoutCadence}`} />}</div>{t20}{t30}</CardContent>;
      if ($[53] !== t31) {
        t11 = <Card>{t31}</Card>;
        $[53] = t31;
        $[54] = t11;
      } else {
        t11 = $[54];
      }
      let t32;
      if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
        t32 = <CardHeader className="pb-2"><CardTitle className="text-base">Deal terms</CardTitle></CardHeader>;
        $[55] = t32;
      } else {
        t32 = $[55];
      }
      let t33;
      if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = <Layers className="size-4 text-muted-foreground" />;
        $[56] = t33;
      } else {
        t33 = $[56];
      }
      const t34 = STRATEGY_LABEL[o.fundingStrategy];
      let t35;
      if ($[57] !== t34) {
        t35 = <Row icon={t33} label="Funding strategy" value={t34} />;
        $[57] = t34;
        $[58] = t35;
      } else {
        t35 = $[58];
      }
      let t36;
      if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
        t36 = <CalendarDays className="size-4 text-muted-foreground" />;
        $[59] = t36;
      } else {
        t36 = $[59];
      }
      let t37;
      if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
        t37 = <Link2 className="size-4 text-muted-foreground" />;
        $[60] = t37;
      } else {
        t37 = $[60];
      }
      t12 = <Card>{t32}<CardContent className="space-y-3 text-sm">{t35}<Row icon={t36} label="Funding deadline" value={formatDate(o.deadlineAt)} /><Row icon={t37} label="Settlement chain" value={o.chain} />{o.revenueShare?.payoutCapUsd && <Row icon={<BadgeCheck className="size-4 text-muted-foreground" />} label="Total payout cap" value={formatUsd(o.revenueShare.payoutCapUsd)} />}</CardContent></Card>;
      let t38;
      if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
        t38 = <CardHeader className="pb-2"><CardTitle className="text-base">Documents</CardTitle></CardHeader>;
        $[61] = t38;
      } else {
        t38 = $[61];
      }
      t13 = <Card>{t38}<CardContent className="space-y-2">{o.legalDocs.map(_temp2)}</CardContent></Card>;
      t6 = "sticky bottom-20 z-20 -mx-4 border-t bg-background/95 px-4 py-3 backdrop-blur";
      T0 = Button;
      t1 = "lg";
      t2 = "w-full";
      t3 = !sellable;
      t4 = () => onBuy(o.id);
      t5 = sellable ? `Buy ${o.tokenSymbol} from ${formatUsd(o.tokenPrice)}` : o.status === "active" ? "Sale closed \u2014 already generating income" : "Not available";
    }
    $[0] = offeringId;
    $[1] = onBack;
    $[2] = onBuy;
    $[3] = T0;
    $[4] = t1;
    $[5] = t10;
    $[6] = t11;
    $[7] = t12;
    $[8] = t13;
    $[9] = t14;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    T0 = $[3];
    t1 = $[4];
    t10 = $[5];
    t11 = $[6];
    t12 = $[7];
    t13 = $[8];
    t14 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  if (t14 !== Symbol.for("react.early_return_sentinel")) {
    return t14;
  }
  let t15;
  if ($[62] !== T0 || $[63] !== t1 || $[64] !== t2 || $[65] !== t3 || $[66] !== t4 || $[67] !== t5) {
    t15 = <T0 size={t1} className={t2} disabled={t3} onClick={t4}>{t5}</T0>;
    $[62] = T0;
    $[63] = t1;
    $[64] = t2;
    $[65] = t3;
    $[66] = t4;
    $[67] = t5;
    $[68] = t15;
  } else {
    t15 = $[68];
  }
  let t16;
  if ($[69] !== t15 || $[70] !== t6) {
    t16 = <div className={t6}>{t15}</div>;
    $[69] = t15;
    $[70] = t6;
    $[71] = t16;
  } else {
    t16 = $[71];
  }
  let t17;
  if ($[72] !== t10 || $[73] !== t11 || $[74] !== t12 || $[75] !== t13 || $[76] !== t16 || $[77] !== t7 || $[78] !== t8 || $[79] !== t9) {
    t17 = <div className={t7}>{t8}{t9}{t10}{t11}{t12}{t13}{t16}</div>;
    $[72] = t10;
    $[73] = t11;
    $[74] = t12;
    $[75] = t13;
    $[76] = t16;
    $[77] = t7;
    $[78] = t8;
    $[79] = t9;
    $[80] = t17;
  } else {
    t17 = $[80];
  }
  return t17;
}
function _temp2(d) {
  return <a key={d.label} href={d.url} className="flex items-center justify-between rounded-lg border p-3 text-sm transition-colors hover:bg-muted"><span className="flex items-center gap-2"><FileText className="size-4 text-muted-foreground" />{d.label}</span><span className="text-xs text-muted-foreground">PDF</span></a>;
}
function _temp(tg) {
  return <Badge key={tg} variant="outline" className="rounded-full font-normal">{tg}</Badge>;
}
function Stat(t0) {
  const $ = _c(11);
  const {
    icon,
    label,
    value,
    hint
  } = t0;
  let t1;
  if ($[0] !== icon || $[1] !== label) {
    t1 = <div className="flex items-center gap-1.5 text-xs uppercase tracking-wide text-muted-foreground">{icon}{label}</div>;
    $[0] = icon;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== value) {
    t2 = <div className="mt-0.5 text-lg font-semibold">{value}</div>;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== hint) {
    t3 = hint && <div className="text-xs text-muted-foreground">{hint}</div>;
    $[5] = hint;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div>{t1}{t2}{t3}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function Row(t0) {
  const $ = _c(8);
  const {
    icon,
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== icon || $[1] !== label) {
    t1 = <span className="flex items-center gap-2 text-muted-foreground">{icon}{label}</span>;
    $[0] = icon;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== value) {
    t2 = <span className="font-medium">{value}</span>;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex items-center justify-between">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}